import $ from "jquery";

const BreadcrumbOverride = (el) => {
    const $el = $(el);
    $el.each(function () {
        let href = $(this).attr("href");

        if (href.endsWith("/business-areas/")) {
            let newHref = href.replace("/business-areas/", "/our-services/");
            $(this).attr("href", newHref);
        }

        if (href.endsWith("/affarsomraden/")) {
            let newHref = href.replace("/affarsomraden/", "/vara-tjanster/");
            $(this).attr("href", newHref);
        }

        if (href.endsWith("/areas-of-expertise/")) {
            let newHref = href.replace("/areas-of-expertise/", "/our-services/");
            $(this).attr("href", newHref);
        }

        if (href.endsWith("/kompetensomraden/")) {
            let newHref = href.replace("/kompetensomraden/", "/vara-tjanster/");
            $(this).attr("href", newHref);
        }
    });
};

export default BreadcrumbOverride;
